module.exports = "https://preprod.web-phone.apps.phone.com/static/media/Montserrat-SemiBold.c641dbee.ttf";